module.exports = {
    GOOD_RATING: 7,
    MIN_VOTES: 100,
};
